/**
 * GraphQL fragment string for view data structure
 * Contains the common view fields used in project config queries
 *
 * ❗❗❗ If making changes here, ensure to update the corresponding fragments in ../index.tsx
 */
export const VIEW_FRAGMENT_STRING = `
  fragment EdgeView on PolarisView {
    __typename
    id
    xid
    name
    emoji
    description @skip(if: $skipDescription)
    uuid @include(if: $isShareViewDialogEnabled)
    containsArchived
    immutable
    visualizationType
    lastCommentsViewedTimestamp
    sortMode
    hideEmptyGroups
    hideEmptyColumns
    groupBy {
        __typename
        key: jiraFieldKey
    }
    verticalGroupBy {
        __typename
        key: jiraFieldKey
    }
    groupValues {
        ...EdgeGroupValue
    }
    verticalGroupValues {
        ...EdgeGroupValue
    }
    sort {
        ...EdgeSorted
    }
    fields {
        __typename
        key: jiraFieldKey
    }
    hidden {
        __typename
        key: jiraFieldKey
    }
    filter {
        ...EdgeFilter
    }
    tableColumnSizes {
        ...EdgeColumnSizes
    }
    fieldRollups {
        ...EdgeFieldRollups
    }
    matrixConfig {
        __typename
        axes {
            __typename
            dimension
            field {
                __typename
                key: jiraFieldKey
            }
            fieldOptions {
                ...EdgeGroupValue
            }
            reversed
        }
    }
    timelineConfig {
        __typename
        summaryCardField {
            __typename
            key: jiraFieldKey
        }
        startDateField {
            __typename
            key: jiraFieldKey
        }
        dueDateField {
            __typename
            key: jiraFieldKey
        }
        mode
        startTimestamp
        endTimestamp
    }
    rank
    viewSetId
    enabledAutoSave
    layoutType
    createdAt
    updatedAt
  }


  fragment EdgeColumnSizes on PolarisViewTableColumnSize {
      __typename
      field {
          __typename
          key: jiraFieldKey
      }
      size
  }

  fragment EdgeFieldRollups on PolarisViewFieldRollup {
      __typename
      field {
          __typename
          key: jiraFieldKey
      }
      rollup
  }

  fragment EdgeSorted on PolarisSortField {
      __typename
      order
      field {
          __typename
          key: jiraFieldKey
      }
    }

  fragment EdgeFilter on PolarisViewFilter {
      __typename
      type: kind
      field {
          __typename
          key: jiraFieldKey
      }
      values {
          ...EdgeFilterValue
      }
  }

  fragment EdgeFilterValue on PolarisViewFilterValue {
      __typename
      stringValue
      numericValue
      enumValue
      operator
  }

  fragment EdgeGroupValue on PolarisGroupValue {
      __typename
      label
      id
  }
`;

/**
 * GraphQL query string for fetching project configuration data
 * This is the main query string used to fetch project details, viewsets, and other configuration
 *
 * ❗❗❗ If making changes here, ensure to update the corresponding fragments in ../index.tsx
 */
export const PROJECT_CONFIG_QUERY_STRING = `
  query jira_polaris_ProjectQuery_reduced(
    $ari: ID!,
    $skipIdeaTypes: Boolean!,
    $isShareViewDialogEnabled: Boolean!,
    $skipDescription: Boolean!,
  ) {
    polarisProject(id: $ari) {
      ...EdgeProjectConfigReducedGQL
    }
  }

  fragment EdgeProjectConfigReducedGQL on PolarisProject {
      __typename
      id
      rankField
      onboarded
      selectedDeliveryProject
      viewsets {
        __typename
        id
        name
        type
        views {
          ...EdgeView
        }
        viewsets {
          __typename
          id
          name
          type
          rank
          views {
            ...EdgeView
          }
        }
      }
      ideaTypes @skip(if: $skipIdeaTypes) {
        __typename
        id
        name
        iconUrl
      }
      onboardTemplate
      onboardedAt
  }
  ${VIEW_FRAGMENT_STRING}
`;
